var map = {
	"./cs-CZ/grafana.json": [
		7299,
		[
			7299
		]
	],
	"./de-DE/grafana.json": [
		23082,
		[
			3082
		]
	],
	"./en-US/grafana.json": [
		19521,
		[
			9521
		]
	],
	"./es-ES/grafana.json": [
		70680,
		[
			680
		]
	],
	"./fr-FR/grafana.json": [
		35648,
		[
			5648
		]
	],
	"./hu-HU/grafana.json": [
		23466,
		[
			3466
		]
	],
	"./id-ID/grafana.json": [
		10130,
		[
			130
		]
	],
	"./it-IT/grafana.json": [
		24453,
		[
			6834
		]
	],
	"./ja-JP/grafana.json": [
		37681,
		[
			7681
		]
	],
	"./ko-KR/grafana.json": [
		43303,
		[
			3303
		]
	],
	"./nl-NL/grafana.json": [
		91716,
		[
			1716
		]
	],
	"./pl-PL/grafana.json": [
		19388,
		[
			7007
		]
	],
	"./pt-BR/grafana.json": [
		12288,
		[
			2288
		]
	],
	"./pt-PT/grafana.json": [
		37996,
		[
			7996
		]
	],
	"./ru-RU/grafana.json": [
		88018,
		[
			8018
		]
	],
	"./sv-SE/grafana.json": [
		51579,
		[
			1579
		]
	],
	"./tr-TR/grafana.json": [
		46208,
		[
			6208
		]
	],
	"./zh-Hans/grafana.json": [
		29538,
		[
			9538
		]
	],
	"./zh-Hant/grafana.json": [
		14791,
		[
			4791
		]
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 3 | 16)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 7170;
module.exports = webpackAsyncContext;